import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import runtime from './runtime';
import intl from './intl';

export default combineReducers({
  runtime,
  intl,
  form: formReducer,
});
